<template>
  <div class="data-grid">
    <div class="header">
      <div class="row small-collapse">
        <div class="small-4 columns">
          <button v-if="addNewEnabled" type="button" name="button" class="button primary neptune small" v-on:click="onAddNewItem"><i class="fi-plus"></i> {{additemtext}}</button>
        </div>
        <div class="small-4 columns">
        </div>
        <div class="small-4 columns text-right">
          <button type="button" name="button" class="button secondary neptune small" v-on:click="onRefresh"><i class="fi-refresh"></i> {{refreshtext}}</button>
        </div>
      </div>
    </div>
    <div class="body">
      <div v-if="!items || !items.length" class="emptytext">{{emptytext}}</div>
      <table class="hover" v-if="items && items.length">
        <thead>
          <tr>
            <th v-for="column of columns" :width="column.width" :align="column.align">{{column.title}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item of items">
            <td v-for="column of columns" :width="column.width" :align="column.align" :class="column.class">
              <span v-if="column.name" class="content-cell" v-html="item[column.name]"></span>
              <span v-if="column.actions" class="actions">
                <span v-for="action of column.actions" class="action">
                  <button type="button" :class="'button tiny ' + action.class" @click="onItemAction(action, item)">
                    <span v-html="action.html" v-if="action.html"></span><span v-if="action.text">{{action.text}}</span>
                  </button>
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'data-grid',
  components: {
  },
  props: {
    items: {
      default: [],
      type: Array
    },
    columns: {
      default: [],
      type: Array
    },
    emptytext: {
      default: 'Nincs megjeleníthető adat.',
      type: String
    },
    additemtext: {
      default: 'Hozzáadás',
      type: String
    },
    refreshtext: {
      default: 'Frissítés',
      type: String
    },
    addNewEnabled: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onAddNewItem () {
      this.$emit('additem')
    },
    onItemClick (item) {
      this.$emit('itemclick', item)
    },
    onItemAction (action, item) {
      this.$emit('itemaction', action, item)
    },
    onRefresh () {
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/foundation-import';
  @import '../../sass/layouts/list';
</style>



// WEBPACK FOOTER //
// DataGrid.vue?79c2c2f3